'use strict';

const { pubdb } = Function('return this')();
const {
    $, date_berlin, debounce, ajax_post, path_root, display_pub,
    trim, ajax_get, encodeBooleanSearch, mustache, base_href,
    activate_tooltips, echo, iframe_dialog, relogin, get_csrf_token, echo_errors,
    get_nice_publication_type_name, add_html_tooltip, copy_obj, mark_erroneous,
    next_tick, make_datepicker, confirm, prompt, foreach_key,
    window, document, kb_ev_enter, kb_ev_cmp, ajax_success_next_handler,
    ajax_success_handler, encode_uri_component, read_form_data,
} = pubdb;
const {
    pub, fields, setTimeout, console, XPathResult, location, JSON, DOMParser,
} = window;
const {
    parse, stringify,
} = JSON;


function focus(el) {
    try {
        $(el).focus();
    } catch (ex) {
        console.log('suppressed exception', ex);
    }
}


var preventing_submit = 0;



// *****************************************************************************
// Author name/data autocompletion:



$(function() {
    var cache = {};

    function source(request, response) {
        function success(data) {
            if (typeof data === 'string') {
                data = parse(data);
            }
            cache[request.term] = data;
            response($.map(data, function(item) {
                item.label = (
                    item.lastname + ', ' +
                    item.firstname + ' ' +
                    (item.we < 100 ? '(WE ' + item.we + ')' : '')
                );
                item.toString = function() {
                    return item.label;
                };
                return {
                    value: item,
                    label: item.label
                };
            }));
        }

        function error() {
            response([]);
        }

        if(request.term in cache) {
            success(cache[request.term]);
        } else {
            ajax_get(
                path_root + '/author/autocomplete/?q=' + encode_uri_component(encodeBooleanSearch(request.term) + '*'),
                success, error, false, true,
            );
        }
    }

    function select(event, ui) {
        $('#lastname').val(ui.item.value.lastname);
        $('#firstname').val(ui.item.value.firstname);
        $('#we').val(ui.item.value.we);
        return false;
    }

    function open() {
        $(this).removeClass('ui-corner-all').addClass('ui-corner-top');
    }

    function close() {
        $(this).addClass('ui-corner-all').removeClass('ui-corner-top');
    }

    $('#lastname').autocomplete({
        source: source,
        minLenght: 2,
        select: select,
        open: open,
        close: close,
        delay: 100,
    });
});



// *****************************************************************************
// Author adding:



function author_list_draw () {
    var table = $('#authors');
    table.find('tbody').disableSelection().html(mustache(
        (
            '{{#authors}}' +
                '<tr>' +
                    '<td>{{lastname}}</td>' +
                    '<td>{{firstname}}</td>' +
                    '<td>{{we}}</td>' +
                    '<td style="padding: 0 0 0 8px">' +
                        '<a href="javascript:void(author_edit({{id}}))">' +
                            '<img src="' + base_href + '/static/icons/gnome/colors-common/22x22/actions/gtk-edit.png" alt="Autor bearbeiten" />' +
                            '<span class="tooltip">Autor&nbsp;bearbeiten</span>' +
                        '</a>&nbsp;' +
                        '<a href="javascript:void(author_del({{id}}))">' +
                            '<img src="' + base_href + '/static/icons/gnome/colors-common/22x22/actions/gtk-delete.png" alt="Autor entfernen" />' +
                            '<span class="tooltip">Autor&nbsp;entfernen</span>' +
                        '</a> ' +
                    '</td>' +
                '</tr>' +
            '{{/authors}}'
        ),
        {authors: pub.authors},
    ));
    activate_tooltips($('img', table));

    function helper (ev, ui) {
        ui.children().each(function() {
            $(this).css('width', $(this).width());
        });
        return ui;
    }

    var start_pos;
    function start (ev, ui) {
        start_pos = ui.item.index();
    }

    function stop (ev, ui) {
        var stop_pos = ui.item.index();
        var item = pub.authors.splice(start_pos, 1)[0];
        pub.authors.splice(stop_pos, 0, item);
        next_tick(author_list_draw);
        return false;
    }

    table.sortable({
        items: 'tbody tr',
        helper: helper,
        start: start,
        stop: stop
    });
}

$(function () {
    function author_load() {
        function author_load_finish (data) {
            if (typeof(data) === 'string') {
                data = parse(data)
            }
            pub.authors = $.extend(true, [], data);
            author_list_draw();
        }

        function req_error(data, err, xhr) {
            echo('warn', 'Fehler (' + data.statusText + ') - bitte versuchen Sie es erneut');
        }

        $('#authors tbody').append('<p>lade Autoren ...</p>');
        ajax_get(path_root + '/pub/' + pub.id + '/authors/', author_load_finish, req_error);
    }

    function author_del(aid) {
        for(var i = 0; i < pub.authors.length; ++i) {
            if(pub.authors[i].id === aid) {
                pub.authors.splice(i, 1);
                author_list_draw();
                break;
            }
        }
    }
    window.author_del = author_del;

    function author_edit (aid) {
        let have_data;

        var iframe = iframe_dialog(
            path_root + '/author/' + aid + '/edit/?content_only&callback=author_saved',
            'Autor bearbeiten',
            onload,
            onunload
        );

        function use_data (data) {
            if(data.id === aid) {
                for(var i = 0; i < pub.authors.length; ++i) {
                    let author = pub.authors[i];
                    if(author.id === aid) {
                        var changed = false;
                        ['firstname', 'lastname', 'we'].forEach(key => {
                            if (author[key] !== data[key]) {
                                changed = true;
                                author[key] = data[key];
                            }
                        });
                        if(changed) {
                            echo('confirm', 'Die Änderungen wurden übernommen.');
                            author_list_draw();
                        } else {
                            echo('confirm', 'Es wurden keine Änderungen vorgenommen.');
                        }
                        return;
                    }
                }
            }
            echo(
                'warn',
                'Ein Kommunikationsfehler mit dem Server ist aufgetreten - bitte versuchen Sie es erneut',
            );
        }

        function onload (cW, ev) {
            cW.author_saved = function (author) {
                if (!iframe) {
                    return;
                }
                iframe.dialog('close');
                iframe = null;
                have_data = author;
            };
        }

        function onunload (cW, ev) {
            function success (data) {
                if (typeof data === 'string') {
                    data = parse(data)[0];
                } else {
                    data = data[0];
                }
                use_data(data);
            }

            function req_error(data, err, xhr) {
                echo(
                    'warn',
                    'Fehler (' + data.statusText + ') ist beim Ändern der Autordaten aufgetreten - bitte versuchen Sie es erneut',
                );
            }

            if (!have_data) {
                ajax_get(path_root + '/author/' + aid + '/', success, req_error);
            } else {
                use_data(have_data);
            }
        }
    }
    window.author_edit = author_edit;

    function author_form_clear() {
        $('#author_form :input:visible:not([type=reset], [type=submit])').val('');
        focus('#author_form [name="lastname"]');
    }

    function author_form_open() {
        $('#author_form').show();
        focus('#author_form [name="lastname"]');
    }

    function author_form_close() {
        author_form_clear();

        $('#author_form').hide();
        focus('#titel');
    }

    function author_add_finish(afterwards) {
        function author_submit_finish(data) {
            if (!data.success) {
                if ('login_required' in data.errors) {
                    relogin();
                } else if ('csrf_token' in data.errors) {
                    get_csrf_token();
                } else {
                    echo_errors(data.errors, '#author_form');
                }
                return;
            }
            pub.authors.push(data.author);
            author_list_draw();

            if(afterwards) {
                afterwards();
            }
        }

        function req_error(data, err, xhr) {
            echo(
                'warn',
                'Fehler (' + data.statusText + ') beim Speichern des Autors aufgetreten - bitte versuchen Sie es erneut',
            );
        }

        var firstname = $('#author_form [name=firstname]').val();
        var lastname = $('#author_form [name=lastname]').val();
        var we = $('#author_form select#we').val();
        var csrf_token = $('#author_form [name=csrf_token]').val();

        if (!lastname) {
            echo('warn', 'Kein Nachname angegeben');
            return;
        }
        if (we === '') {
            echo('warn', 'Kein Mitarbeiterstatus angegeben');
            return;
        }

        ajax_post($('#author_form form').attr('action'), {
            firstname: firstname,
            lastname: lastname,
            we: we,
            csrf_token: csrf_token
        }, author_submit_finish, req_error);
    }

    var shift_pressed = false;
    $(document).on('keyup keydown', function (ev) {
        if (kb_ev_cmp(ev, 27, 'Escape') && ev.shiftKey) {
            ev.preventDefault();
            author_form_close();
        }
    });
    $('#author_form').
            on('reset', author_form_close).
            on('submit', function(e) {
                next_tick(function () {
                    author_add_finish(shift_pressed ? author_form_clear : author_form_close);
                });
                return false;
            }).find('input, select, button').on('keydown', function (ev) {
                if(kb_ev_enter(ev)) {
                    ev.preventDefault();
                    $('#author_form').submit();
                }
            });

    if (pub.authors.length) {
        author_list_draw();
    } else if (pub.id) {
        author_load();
    }

    $('#open_author_form').click(function (ev) {
        ev.preventDefault();
        next_tick(author_form_open);
    });
});



// *****************************************************************************
// Add tooltips:



$(function() {
    focus('#titel');
    $('span.publication_type').text(get_nice_publication_type_name(pub.typ, true));
    $('img.publication_type').attr('title', get_nice_publication_type_name(pub.typ, true));

    $.map(fields, function (item) {
        var l = $('#main_form label[for="' +item[0]+ '"]');
        if (item[1]) {
            $('<div class="tooltip">Pflichtfeld</div>').prependTo(l);
            activate_tooltips($('<strong style="color:crimson; font-size:140%">*\xA0</strong>').prependTo(l));
        }
        if (item[2]) {
            add_html_tooltip(l, item[2]);
        }
    });
});



// *****************************************************************************
// Show matching fields for subtype:



$(function () {
    $('#main_form select#subtype').each(function () {
        var current_subtype;
        $(this).on('change focus blur keyup', function () {
            var new_subtype = $(this).val();
            if (current_subtype === new_subtype) {
                return;
            }
            if (new_subtype) {
                $('#' + new_subtype).stop(true, true).slideDown('medium');
            }
            if (current_subtype) {
                $('#' + current_subtype).stop(true, true).slideUp('medium');
            }
            current_subtype = new_subtype;
        }).change();
    });
});



// *****************************************************************************
// Prevent accidential leaving the page w/o saving:



function populate_pub (dest) {
    read_form_data({ data: dest, form: '#main_form', visible_only: true, include_hidden: true });
}

$(function() {
    var orig_data, orig_authors;
    next_tick(function () {
        populate_pub(pub);
        orig_data = copy_obj(pub);

        orig_authors = [];
        for (var i = 0, a = pub.authors, len = a.length; i < len; ++i) {
            orig_authors.push(a[i].id);
        }
    });

    $(window).on('beforeunload', function() {
        var ex_unsaved = {};
        var a = pub.authors;
        try {
            if (a.length !== orig_authors.length) {
                throw ex_unsaved;
            }

            for (var i = 0, len = a.length; i < len; ++i) {
                if (a[i].id !== orig_authors[i]) {
                    throw ex_unsaved;
                }
            }

            populate_pub(pub);
            for (var i = 0, len = fields.length; i < len; ++i)  {
                var f = fields[i][0];
                if (pub[f] !== orig_data[f]) {
                    throw ex_unsaved;
                }
            }
        } catch (e) {
            if (e === ex_unsaved) {
                return 'Es existieren ungesicherte Änderungen.';
            }
            throw e;
        }
    });
});



// *****************************************************************************
// Saving the changes:



$(function() {
    function form_submit_finish (resp) {
        switch (ajax_success_next_handler(resp)) {
            case 'next':
            case 'callback':
                // TODO: FIXME: window.onbeforeunload wird nirgends gesetzt, oder?
                window.onbeforeunload = null
        }
    }

    function req_error(data, err, xhr) {
        echo('warn', 'Fehler (' + data.statusText + ') - bitte versuchen Sie es erneut');
    }

    function confirm_next (text, next) {
        const IGNORE_MSG = 'Fehler ignorieren';
        const { dialog } = confirm('Nachfrage vor dem Speichern', text, [['überarbeiten'], [IGNORE_MSG, next]]);
        let seconds = 3;
        next_tick(function () {
            const confirm_bnt = dialog.parent().find('>.ui-dialog-buttonpane button:last');
            confirm_bnt.prop('disabled', true).css('cursor', 'not-allowed');
            (function delay () {
                if (seconds > 0) {
                    confirm_bnt.text(`${IGNORE_MSG} (${seconds})`);
                    --seconds;
                    setTimeout(delay, 900);
                } else {
                    confirm_bnt.prop('disabled', false).css('cursor', 'unset').text(IGNORE_MSG);
                }
            } ());
        });
    }

    function kongress_X_okay (field) {
        return function (next) {
            if (pub[field]) {
                var e = /^\s*(\d{1,2})\.(\d{1,2})\.(\d{2}|\d{4})\s*$/.exec(pub[field]);
                if (!e) {
                    var err = 'Der Veranstaltungszeitraum des Kongresses ist kein gültiges Datum (TT.MM.YYYY).';
                } else {
                    if (e[3].length === 2) {
                        e[3] = (+e[3] < 30 ? '20' : '19') + e[3];
                        pub[field] = e[1] + '.' + e[2] + '.' + e[3];
                        $('#main_form input[name="' + field + '"]').val(pub.kongress_ende);
                    }
                    if (+e[3] < 1904 || +e[3] > 2030) {
                        var err = 'Der Veranstaltungszeitraum muss zwischen 1904 und 2030 liegen.';
                    }
                }
            }
            if (err) {
                var obj = {};
                obj[field] = [err];
                echo_errors(obj, '#main_form');
            } else {
                next();
            }
        };
    }

    let ignored_messages = [];
    const ignored_messages_tests = [
        function bandzaehlung_okay (next) {
            var el = $('#main_form form label[for=bandzaehlung]').get(0);
            if (el && pub.bandzaehlung
                   && /\D/.exec(pub.bandzaehlung)
                   && !pub.heftzaehlung
                   && $('#main_form form [name=heftzaehlung]:visible').length) {
                ignored_messages.push('bandzaehlung_okay');
                el.scrollIntoView(true);
                confirm_next(
                    'Die angegebene Bandzählung ist ungewöhnlich. Bitte überprüfen Sie, ob Sie die Bandzählung und die Heftzählung vermischt haben.',
                    next,
                );
                return;
            }
            next();
        },
        function case_okay (next) {
            var el = $('#main_form form label[for=titel]').get(0);
            if (el && !/[A-ZÄÖÜ]/.exec(pub.titel) || !/[a-zäöüß]/.exec(pub.titel)) {
                el.scrollIntoView(true);
                ignored_messages.push('case_okay');
                confirm_next(
                    'Die Schreibweise des Titels ist ungewöhnlich. Bitte überprüfen Sie, ob die Groß-/Kleinschreibung korrekt ist.',
                    next,
                );
                return;
            }
            next();
        },
        function titel_no_period_okay (next) {
            var el = $('#main_form form label[for=titel]').get(0);
            if (el && /\.$/.exec(pub.titel)) {
                el.scrollIntoView(true);
                ignored_messages.push('titel_no_period_okay');
                confirm_next(
                    'Der Titel sollte nicht auf einen Punkt enden. Abkürzungen sind davon natürlich ausgenommen.',
                    next,
                );
                return;
            }
            next();
        },
        function firstnames_okay (next) {
            for (var i = 0; i < pub.authors.length; ++i) {
                if (!pub.authors[i].firstname) {
                    ignored_messages.push('firstnames_okay');
                    $('#main_form form label[for=open_author_form]').get(0).scrollIntoView(true);
                    confirm_next(
                        'Sie haben nicht bei allen Autoren einen Vornamen angegeben.',
                        next,
                    );
                    return;
                }
            }
            next();
        },
        function chose_we_okay (next) {
            let { authors } = pub;
            for (let i = 0, { length } = authors; i < length; ++i) {
                let { we } = authors[i];
                if (we && (we !== 'Kein FU-Angehöriger (extern)') && (we !== 'Anderer Fachbereich')) {
                    next();
                    return;
                }
            }
            ignored_messages.push('chose_we_okay');
            $('#main_form form label[for=open_author_form]').get(0).scrollIntoView(true);
            confirm_next(
                'Sie haben bei keinem der Autoren eine wissenschaftliche Einrichtung eingetragen.',
                next,
            );
        },
        function doi_valid_format (next) {
            var el = $('#main_form form label[for=doi]').get(0);
            if (el && pub.doi && !/^10\.\d{4,}(?:\.\d+)*\/(?:[a-z]+\.)?[^\0- \s"&'<>]+$/isu.exec(pub.doi)) {
                ignored_messages.push('doi_valid_format');
                el.scrollIntoView(true);
                confirm_next(
                    'Die angegebene DOI scheint ein ungültiges Format zu haben.',
                    next
                );
                return;
            }
            next();
        },
        function doi_not_a_url_okay (next) {
            var el = $('#main_form form label[for=doi]').get(0);
            if (el && pub.doi && /^https?:\/*/i.exec(pub.doi)) {
                ignored_messages.push('doi_not_a_url_okay');
                el.scrollIntoView(true);
                confirm_next(
                    'Bei dem angegebenen DOI scheint es sich um eine URL zu handeln.',
                    next,
                );
                return;
            }
            next();
        },
        function display_for_we_okay (next) {
            var el = $('#main_form form label[for=we]').get(0);
            if (el && pub.we ==/*sic*/ 0) {
                ignored_messages.push('display_for_we_okay');
                el.scrollIntoView(true);
                confirm_next(
                    'Die Publikation wird auf keiner Webseite einer wissenschaftlichen Einrichtung erscheinen.',
                    next,
                );
                return;
            }
            next();
        },
        function erscheinungsjahr_okay (next) {
            if (pub.erscheinungs_jahr) {
                var e = /^\s*(\d{2}|\d{4})\s*$/.exec(pub.erscheinungs_jahr);
                if (!e) {
                    var err = 'Das Erscheinungsjahr ist ungültig';
                } else {
                    if (e[1].length === 2) {
                        e[1] = (+e[1] < 30 ? '20' : '19') + e[1];
                        pub.erscheinungs_jahr = e[1];
                        $('#main_form input[name=erscheinungs_jahr]').val(e[1]);
                    }
                    if (+e[1] < 1904 || +e[1] > 2030) {
                        var err = 'Das Erscheinungsjahr muss zwischen 1904 und 2030 liegen.';
                    }
                }
            }
            if (err) {
                echo_errors({ erscheinungs_jahr: [err] }, '#main_form');
            } else {
                next();
            }
        },
        function kongress_zeitraum_okay (next) {
            var el1 = $('#main_form form label[for=kongress_datum]').get(0);
            var el2 = $('#main_form form label[for=kongress_ende]').get(0);
            if (el1 && el2 && pub.kongress_ende) {
                if (!pub.kongress_datum) {
                    echo_errors({ kongress_ende: ['Die Angabe des Kongressendes ohne -anfang ist unsinnig.'] }, '#main_form');
                    return;
                } else {
                    var e = /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/.exec(pub.kongress_datum);
                    var kongress_datum = new Date(e[3], e[2] - 1, e[1]);

                    var e = /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/.exec(pub.kongress_ende);
                    var kongress_ende = new Date(e[3], e[2] - 1, e[1]);

                    if (+kongress_datum > +kongress_ende) {
                        ignored_messages.push('kongress_zeitraum_okay');
                        confirm_next(
                            'Der letzte Tag des Kongresses liegt vor dem ersten.',
                            next,
                        );
                        return;
                    }
                }
            }
            next();
        },
        kongress_X_okay('kongress_ende'),
        kongress_X_okay('kongress_datum'),
        function kongressband_one_author (next) {
            if (pub.subtype === "kongressband" && pub.authors.length < 2) {
                ignored_messages.push('kongressband_one_author');
                $('#main_form form label[for=open_author_form]').get(0).scrollIntoView(true);
                confirm_next(
                    'Beiträge zu Kongressbänden haben häufig mehrere Autoren. \
                    Sind Sie sich sicher, dass dieser nur einen Autor hat und es keine weiteren Beitragenden gab?',
                    next,
                );
                return;
            }
            next();
        },
    ];

    function submit () {
        if (preventing_submit) {
            return;
        }

        var aborted = false;
        fields.forEach(function(f) {
            if(!f[1]) {
                return;
            }
            var field = $('#main_form [name="' + f[0] + '"]:visible');
            if(!field.length || field.val()) {
                return;
            }
            mark_erroneous(field);

            if (!aborted) {
                aborted = true;
                echo('warn', 'Bitte füllen Sie alle mit einem Sternchen markierten Felder aus.');
                focus('#main_form [name="' +f[0]+ '"]');
                $('#main_form label[for="' +f[0]+ '"]').get(0).scrollIntoView(true);
            }
        });
        if (aborted) {
            return;
        }
        if (!pub.authors.length && pub.typ !== 'pressespiegel') {
            echo('warn', 'Sie haben noch keine Autoren eingetragen.');
            $('label[for=open_author_form]').get(0).scrollIntoView(true);
            return;
        }

        populate_pub(pub);
        pub.csrf_token = $('#main_form input[name=csrf_token]').val();

        ignored_messages = [];
        (function test_tests (index) {
            let test = ignored_messages_tests[index];
            if (test) {
                test(function () {
                    test_tests(index - 1);
                });
            } else {
                if (ignored_messages.length) {
                    pub.ignored_messages = ignored_messages;
                } else {
                    delete pub.ignored_messages;
                }
                ajax_post($('#main_form form').attr('action'), pub, form_submit_finish, req_error);
            }
        } (ignored_messages_tests.length - 1));
    }

    $('#main_form').submit(function (ev) {
        ev.preventDefault();
        next_tick(submit);
        return false;
    }).find(':input:not(textarea, :checkbox, :radio)').keyup(function (ev) {
        if (ev.which !== 13 && ev.which !== 10) {
            return;
        }

        if(!$(this).data('is-invalid')) {
            next_tick(submit);
        }

        return false;
    }).on('keydown keyup', function (ev) {
        if (ev.which !== 13 && ev.which !== 10) {
            return;
        }

        return false;
    });
});



// *****************************************************************************
// Preview:



$(function () {
    var w = null;

    function form_submit_finish(data, err, xhr) {
        if (!data.success) {
            try {
                w.close();
            } catch (e) {
                // pass
            }
            w = null;
            if ('login_required' in data.errors) {
                relogin();
            } else if ('csrf_token' in data.errors) {
                get_csrf_token();
            } else {
                echo_errors(data.errors, '#main_form');
            }
            return;
        }

        try {
            if (!w.document.documentElement.outerHTML || typeof w.document.documentElement.outerHTML !== 'string') {
                throw {};
            }
            w.document.documentElement.outerHTML = data.data.html;
        } catch (_) {
            w.document.documentElement.innerHTML = data.data.html;
        }

        $(w.document).ready(function () {
            var pubdb_id = w.$('#PubDB').css({
                margin: '1em',
                padding: '1ex'
            });
            var dest = $('<div/>', {
                appendTo: w.$('<div/>', {
                    'class': 'PubDB',
                    style: 'margin: 1em; padding: 1ex;',
                    insertBefore: pubdb_id
                })
            });
            w.pubdb.display_list(data.data.pub, dest);
        });
    }

    function req_error(data, err, xhr) {
        echo('warn', 'Fehler (' + data.statusText + ') - bitte versuchen Sie es erneut');
    }

    function empty_loaded (content_window) {
        w = content_window;
        w.$('#PubDB').append($('<div/>', {
          'class': 'throbber'
        }));

        populate_pub(pub);
        pub.csrf_token = w.pubdb.csrf_token;
        ajax_post($('#main_form form').attr('action') + '?preview&content_only', pub, form_submit_finish, req_error);
    }

    $('#form_preview').click(function (ev) {
        next_tick(function () {
            iframe_dialog(path_root + '/empty/?content_only', 'Vorschau', empty_loaded);
        });
        return false;
    });
});



// *****************************************************************************
// Find possible duplicates for new pub:



if ((pub.id === 0) && pub.typ) { $(function () {
    const container_list = $('<ol/>', {
        css: {
            fontSize: '90%',
            lineHeight: '1.4em',
        },
    });
    container_list.on('click', 'a', function (ev) {
        this.target = '_blank';
    });
    const container = $('<div/>', {
        css: {
            width: '100%',
            maxWidth: '1600px',
            margin: 'auto',
            height: '25rem',
            maxHeight: '20%',
            minHeight: '15rem',
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            background: 'rgba(255,255,255,0.95)',
            boxShadow: '0 0 1rem rgba(0,0,0,0.75)',
            padding: '0 1rem 0.25rem 1rem',
            display: 'none',
            zIndex: 10,
            overflowY: 'auto',
        },
        append: [
            $('<h4>', { text: 'Es wurden mögliche Duplikate gefunden. Bitte vergewissern Sie sich, ob diese Publikation nicht bereits eingetragen wurde!' }),
            container_list,
        ],
        appendTo: document.body,
    });

    const keys = [];
    const inputs = [];
    const cache = Object.create(null);

    let modification_counter = 0;
    let last_value = [];
    let valid_modification_counter = null;
    let dups_shown = false;

    function show_dups (data) {
        if (!data || !data.length) {
            hide_dups();
        } else {
            valid_modification_counter = 0;
            container_list.empty();

            for (let i = 0, l = data.length; i < l; ++i) {
                const li = $('<li/>')
                display_pub([data[i]], li);
                $('<p>', { appendTo: li });
                li.appendTo(container_list);
            }
            container.show();
            dups_shown = true;
        }
    }

    function hide_dups() {
        if (dups_shown) {
            last_value = [];
            valid_modification_counter = 0;
            container_list.empty();

            container.hide();

            dups_shown = false;
        }
    }

    const onchange = debounce(function (ev) {
        let value = null;
        let form = {
            csrf_token: pubdb.csrf_token,  // do not capture csrf_token
            typ: pub.typ,
        };
        const current_value = [];
        let cache_prev = null;
        let cache_end = cache;
        let changed = 0;

        for (let i = 0, l = keys.length; i < l; ++i) {
            value = inputs[i].val();
            if (typeof value === 'string') {
                value = trim(value);
            }
            form[keys[i]] = value;
            current_value.push(value);
            cache_prev = cache_end;
            if (cache_end[value] != null) {
                cache_end = cache_end[value];
            } else {
                cache_end = cache_end[value] = {};
            }
            changed += (last_value[i] !== value);
        }

        if (!changed) {
            // unchanged
            return;
        }

        if (!form.titel) {
            hide_dups();
            return;
        }

        if (cache_end === +cache_end) {
            if (cache_end) {
                // currently querying
                valid_modification_counter = cache_end;
            } else {
                // cached error
                hide_dups();
            }
            return;
        }

        if (cache_end.length === +cache_end.length) {
            // cached result
            show_dups(cache_end);
            last_value = current_value;
            return;
        }

        cache_prev[value] = 0;  // if Ajax call fails, cache as error.

        const index = ++modification_counter;
        const xhr = ajax_post(`${path_root}/pub/new/possible-dups/`, form, onsuccess, onerror);

        valid_modification_counter = index;
        cache_prev[value] = index;

        function onsuccess (response) {
            let { success, data } = response || {};
            if (!success) {
                data = 0;  // cache error, hide dups
            }

            cache_prev[value] = data;
            if (valid_modification_counter === index) {
                show_dups(data);
                last_value = current_value;
            }
        }

        function onerror () {
            console.log('error', {xhr});
            cache_prev[value] = 0;  // cache error
        }
    }, 360);
    onchange();

    const field_names = ['titel', 'untertitel', 'we', 'journal_id', 'kongress_datum'];
    for (let i = 0, l = field_names.length; i < l; ++i) {
        const field_name = field_names[i];
        const field_input = $('#' + field_name);
        if (field_input.length !== 1) {
            continue;
        }

        keys.push(field_name);
        inputs.push(field_input);

        field_input.on('click change keyup focus blur paste cut mouseup', onchange);
    }
}); }



// *****************************************************************************
// Select a Forschungsprojekt:



$(function() {
    var fields = $('#forschungsprojekt_id');
    if (!fields.length) {
        return;
    }
    fields.each(function () {
        var old_id;
        var iframe;
        var field = $(this);

        function chose_fp (data) {
            changed_id(data);
            iframe.dialog('close');
            outer_div.prev('label').get(0).scrollIntoView(true);
        }

        function choose_fp () {
            if (iframe) {
                return;
            }
            iframe = iframe_dialog(
                path_root + '/forschungsprojekt/choose/?content_only&callback=chose_fp',
                'Zugehöriges Forschungsprojekt auswählen',
                function (cW) { cW.chose_fp = chose_fp; },
                function (cW) { iframe = null; }
            );
        }

        function success (data) {
            if (!data) {
                field.val('');
                changed_id();
            } else {
                const { id, titel_ger, titel_eng } = data;
                text_div.html($('<a/>', {
                    href: path_root + '/forschungsprojekt/' + id + '/',
                    target: '_new',
                    text: titel_ger || titel_eng
                }));
                $('#main_form [name=forschungsprojekt_id]').val(id);
            }
        }

        function req_error(data, err, xhr) {
            echo('warn', 'Fehler (' + data.statusText + ') - bitte versuchen Sie es erneut');
        }

        function changed_id (data) {
            if (typeof data !== 'undefined') {
                var new_id = data && String(data.id);
            } else {
                var new_id = field.val();
                if (new_id === old_id) {
                    return;
                }
            }

            assign_button.text((new_id ? 'Anderem' : 'Einem') + ' Forschungsprojekt zuordnen');
            if (!new_id) {
                field.val('');
                old_id = '';
                text_div.html('<i>Kein Forschungsprojekt gewählt</i>');
            } else {
                old_id = new_id;
                if (!data) {
                    ajax_get(path_root + '/forschungsprojekt/' + new_id + '/', success, req_error);
                } else {
                    success(data);
                }
            }
        }

        var outer_div = $('<div/>').css({
            position: 'relative',
            'margin-top': '8px',
            'margin-left': '10px'
        });
        var text_div = $('<div/>').appendTo(outer_div).attr({
            'class': 'main_form'
        }).css({
            'z-index': +1,
            position: 'relative',
            top: 0
        });
        var input_div = $('<div/>').appendTo(outer_div).css({
            'z-index': -1,
            position: 'absolute',
            top: 0
        });
        var assign_button = $('<button/>').appendTo(outer_div).click(function () {
            next_tick(choose_fp);
            return false;
        });
        field.replaceWith(outer_div).appendTo(input_div);

        changed_id();
    });
});



// *****************************************************************************
// Select a Journal:


$(function () {
    var iframe = null;
    var field = $('#journal_id');

    function onunload (ev) {
        const cur_iframe = iframe;
        if (!cur_iframe) {
            return;
        }

        iframe = null;
        cur_iframe.dialog('close');

        setTimeout(function () {
            --preventing_submit;
        }, 360);
    }

    function chose_journal (data) {
        if (!data) {
            return;
        }
        if (!$('option[value="' + data.id + '"]', field).length) {
            $('<option/>').text(data.title + ' (' + data.issn + ')').attr({
                value: data.id
            }).appendTo(field);
        }
        found_journal(data);
    }

    function found_journal (data) {
        if (!data) {
            return;
        }
        var el = field.val(data.id)[0];
        try {
            el.focus();
        } catch (ex) {
            console.log('suppressed exception', ex);
        }
        try {
            el.scrollIntoView(true)
        } catch (ex) {
            console.log('suppressed exception', ex);
        }
        onunload();
    }

    function add (cb) {
        function add_loaded (content_window, _ev) {
            content_window.chose_journal = chose_journal;
            if (cb) {
                content_window.$(function () {
                    cb(content_window);
                });
            }
        }

        ++preventing_submit;
        iframe = iframe_dialog(
            `${path_root}/journal/new/?content_only&callback=chose_journal`,
            'Neue Fachzeitschrift hinzufügen',
            add_loaded, onunload,
        );
    }
    pubdb.pubdb_new_journal_add = add;

    function search (cb) {
        function search_loaded (content_window, _ev) {
            content_window.found_journal = found_journal;
            if (cb) {
                content_window.$(function () {
                    cb(content_window);
                });
            }
        }

        ++preventing_submit;
        iframe = iframe_dialog(
            path_root + '/journal/search/?content_only&callback=found_journal',
            'Fachzeitschrift suchen', search_loaded, onunload,
        );
    }
    pubdb.pubdb_new_journal_search = search;

    function change () {
        var val = field.val();
        if (iframe !== null || !val || val[0] !== '-') {
            return;
        }
        field.val('');
    }

    field.on('change blur', function () {
        next_tick(change);
    });

    function action_button (cb, img, title) {
        $('<a/>', {
            text: title,
            href: 'javascript:void(0)',
            click () {
                next_tick(cb);
                return false;
            },
            prepend: $('<img/>', {
                src: base_href + '/static/icons/gnome/colors-common/16x16/actions/' + img + '.png',
                alt: '',
                css: {
                    'padding-right': '0.5ex'
                }
            }),
            css: {
                'padding': '0 1em'
            },
            insertBefore: field,
        });
    }
    action_button(search, 'gnome-searchtool', 'Fachzeitschrift suchen');
    action_button(add, 'gtk-save-as', 'Fachzeitschrift hinzufügen');

    if (field.val() === '-') {
        field.val('');
    }
});



// *****************************************************************************
// Misc:



$(function () {
    make_datepicker('#main_form [name=datum]', 'datetimepicker');
    make_datepicker('#main_form [name=kongress_datum]', 'datepicker');
    make_datepicker('#main_form [name=kongress_ende]', 'datepicker');

    var we = $('#main_form [name=we]');
    if (we.val() === '') {
        we.val('0');
    }

    const { hash } = location;
    if (/^(#\w+)$/.exec(hash)) {
        setTimeout(function () {
            const elem = document.querySelector(hash);
            if (elem) {
                elem.focus();
                elem.scrollIntoView(true);
            }
        }, 180);
    }
});



// *****************************************************************************
// Read DOI / PubMed:



$(function () {
    var NO_RESULT_FOUND = {};

    function set (dest, datum, dollar) {
        (dollar || $)('#main_form [name="' + dest + '"]').css({
            'box-shadow': '0 0 9px #0000a4'
        }).val(datum).trigger('change').one('focus', function () {
            $(this).css({
                'box-shadow': ''
            });
        });
    }

    function eval_path (root, path, type, dest) {
        switch (type) {
            case 'STRING':
            case 'NUMBER':
            case 'BOOLEAN':
                var xType = type + '_TYPE';
                break;
            case 'ANY':
            case 'FIRST':
                var xType = type + '_ORDERED_NODE_TYPE';
                break;
            case 'ORDERED':
            case 'UNORDERED':
                var xType = type + '_NODE_ITERATOR_TYPE';
                break;
        }
        var result = (root && pubdb.pub_new_import_data.evaluate(path, root, null, XPathResult[xType], null)) || Object.create(null);
        switch (type) {
            case 'STRING':
                result = result.stringValue;
                if (dest) {
                    set(dest, result);
                }
                break;
            case 'NUMBER':
                result = result.numberValue;
                break;
            case 'BOOLEAN':
                result = result.booleanValue;
                break;
            case 'ANY':
            case 'FIRST':
                result = result.singleNodeValue;
                break;
            case 'ORDERED':
            case 'UNORDERED':
                return function () {
                    return result.iterateNext();
                };
                break;
        }
        return result;
    }

    function success_pubmed (data) {
        var article = eval_path(data, '/PubmedArticleSet/PubmedArticle/MedlineCitation/Article', 'FIRST');

        set('titel', (eval_path(article, './VernacularTitle', 'STRING') ||
                      eval_path(article, './ArticleTitle', 'STRING')).replace(/^\s+|(\s*\.)?\s*$/g, ''));

        eval_path(article, './ELocationID[@EIdType="doi"]', 'STRING', 'doi');

        var pagination = eval_path(article, './Pagination/MedlinePgn', 'STRING');
        if (pagination) {
            pagination = pagination.split(/-/, 2);
            if (pagination.length === 1) {
                pagination = [pagination, pagination];
            }
            var p0 = String(pagination[0]), p1 = String(pagination[1]);
            p1 = p0.substr(0, p0.length - p1.length) + p1;
            set('seitenzahl', p0);
            set('seitenzahl_ende', p1);
        }

        var journal = eval_path(article, './Journal', 'FIRST');
        eval_path(journal, './JournalIssue/Volume', 'STRING', 'bandzaehlung');
        eval_path(journal, './JournalIssue/Issue', 'STRING', 'heftzaehlung');
        if (!eval_path(journal, './JournalIssue/PubDate/Year', 'STRING', 'erscheinungs_jahr')) {
            var e = /^(\d{4})\b/.exec(eval_path(journal, './JournalIssue/PubDate/MedlineDate', 'STRING'));
            if (e) {
                set('erscheinungs_jahr', e[1]);
            }
        }

        set_issn(eval_path(journal, './ISSN', 'STRING'), {
            title:  eval_path(journal, './Title', 'STRING'),
            abbrev: eval_path(journal, './ISOAbbreviation', 'STRING'),
        });

        var abstractIter = eval_path(article, './Abstract/AbstractText', 'ORDERED');
        var abstracts = [], abstractI;
        while ( (abstractI = abstractIter()) !== null) {
            abstracts.push(trim(abstractI.textContent.replace(/^ABSTRACT(\s*[:;.,-])*/i, '')) + '\n');
        }
        set('abstract', abstracts.join('\n'));

        var lang = eval_path(article, './Language', 'STRING');
        if (lang) {
            for (let i = 0, {langs} = pubdb, {length} = langs; i < length; ++i) {
                let l = langs[i];
                if (l['iso639-2b'] === lang) {
                    set('sprache', l['iso639-1']);
                    break;
                }
            }
        }

        add_authors_by_iter_generic(
            eval_path(article, './AuthorList/Author', 'ORDERED'),
            authorI => ({
                firstname: eval_path(authorI, './ForeName', 'STRING'),
                lastname:  eval_path(authorI, './LastName', 'STRING'),
            }),
        );
    }

    function set_issn (issn, journal_info) {
        function success_issn (data) {
            if (data.length === 1) {
                set('journal_id', data[0].id);
            } else if (data.length === 0) {
                pubdb.pubdb_new_journal_add(function (cW) {
                    cW.pubdb.echo('confirm', 'Es wurde noch keine Fachzeitschrift mit der ISSN "' + issn + '" eingetragen.');
                    set('issn', issn, cW.$);
                    foreach_key(journal_info, key => { set(key, journal_info[key], cW.$); });
                });
            } else {
                pubdb.pubdb_new_journal_search(function (cW) {
                    cW.pubdb.echo('confirm', 'Es gibt mehrere Fachzeitschriften, die auf die ISSN "' + issn + '" passen.');
                    set('q', issn, cW.$);
                });
            }
        }

        function error_issn (data, err, xhr) {
            echo('warn', 'Die Fachzeitschrift konnte aufgrund einer Fehlermeldung (' + data.statusText + ') nicht ausgelesen werden.');
        }

        if (issn) {
            if (issn.length === 9) {
                issn = issn.substring(0,4) + issn.substring(5,9);
            }

            ajax_get(path_root + '/journal/issn/' + issn + '/', success_issn, error_issn);
        }
    }

    function add_authors_by_iter_generic (authorIter, convert) {
        var authorI;
        var info_adding_authors;

        function finish_add_authors () {
            author_list_draw();
            if (info_adding_authors) {
                info_adding_authors.click();
            }
        }

        function proceed_next () {
            authorI = authorIter();
            if (authorI !== null) {
                next_tick(add_authorI);
                return true;
            }
        }

        function author_submit_finish (resp) {
            if (!ajax_success_handler(resp)) {
                echo('warn', 'Es konnte nicht alle Autoren hinzugefügt werden!');
            } else {
                const { author } = resp;
                pub.authors.push(author);
                if (proceed_next()) {
                    return;
                }
            }

            finish_add_authors();
        }

        function req_error (data, err, xhr) {
            echo('warn', 'Fehler (' + data.statusText + ') beim Eintragen eines Autors aufgetreten.');
            echo('warn', 'Es konnte nicht alle Autoren hinzugefügt werden!');

            finish_add_authors();
        }

        function add_authorI () {
            let data = convert(authorI);
            if (data) {
                let { lastname, firstname, we } = data;
                data = {
                    lastname,
                    firstname: firstname || '',
                    we: stringify(!we ? 101 : 1 <= we && data.we <= 20 ? we : 100),
                    csrf_token: $('#author_form input[name=csrf_token]').val()
                };
                ajax_post($('#author_form form').attr('action'), data, author_submit_finish, req_error);
            } else if (!proceed_next()) {
                finish_add_authors();
            }
        }

        if (proceed_next()) {
            pub.authors = [];
            info_adding_authors = echo('confirm', 'Füge Autoren hinzu …');
        }
    }

    function add_authors_by_iter_lastname_comma_firstname (authorIter) {
        function convert (authorI) {
            var lastname = authorI.textContent
            var firstname = '';
            var e = /^(.*?)\s*,\s*(.*?)$/.exec(lastname);
            if (e) {
                firstname = e[2];
                lastname = e[1];
            }
            return { firstname, lastname };
        }
        add_authors_by_iter_generic(authorIter, convert);
    }

    function success_sep (data) {
        var section_data = eval_path(data, '/sep/data', 'FIRST');

        function from_doc (src, dest, doc) {
            return eval_path(doc || section_data, './field[@name="' + src + '"]', 'STRING', dest);
        }

        let e;

        if ((e = /^<<([^>]+)>>(.*)$/.exec(from_doc('Titel des Aufsatzes', 'titel') || ''))) {
            set('titel', e[1] + e[2]);
        }
        if ((e = /(\d+)\s*Seiten/.exec(from_doc('Seiten von bis', 'seitenzahl') || ''))) {
            set('seitenzahl', e[1]);
        }
        if ((e = /WE\s*(\d+)/.exec(from_doc('Bibliographieüberschrift') || ''))) {
            set('we', +e[1]);
        }
        from_doc('DOI', 'doi');
        from_doc('Untertitel', 'untertitel');
        from_doc('Bandzählung', 'bandzaehlung');
        from_doc('Heftzählung', 'heftzaehlung');
        from_doc('URL', 'url');

        if ((e = from_doc('Sprache'))) {
            for (let i = 0, {langs} = pubdb, {length} = langs || []; i < length; ++i) {
                let l = langs[i];
                if (l.ger_name === e) {
                    set('sprache', l['iso639-1']);
                    break;
                }
            }
        }

        set_issn(from_doc('ISSN'), {
            title:            from_doc('Titel der Zeitschrift'),
            erscheinungs_ort: from_doc('Erscheinungsort'),
            verlag:           from_doc('Verlag'),
        });

        add_authors_by_iter_generic(
            eval_path(data, '/sep/authors/author', 'ORDERED'),
            function (authorI) {
                let firstname = (from_doc('Vorname in Publikation', 0, authorI) || from_doc('Vorname', 0, authorI));
                let lastname = (from_doc('Name in Publikation', 0, authorI) || from_doc('Name', 0, authorI));
                let org = from_doc('Organisationseinheit', 0, authorI) || '';
                let we = +(/^5048(\d{2})00/.exec(org) || [])[1];
                if ((!we || we !== we) && /^\d+ /.exec(org)) {
                    we = 100;
                }
                return { firstname, lastname, we };
            },
        );
    }

    function success_refubium (data) {
        var doc = eval_path(data, '/refubium', 'FIRST');

        function from_doc (src, dest, translator) {
            var iter = eval_path(doc, './field[@name="' + src + '"]', 'ORDERED');

            var best_match = '';
            for (;;) {
                var match = iter();
                if (!match) {
                    break;
                }
                if (!best_match) {
                    best_match = match;
                }
                var cur_lang = (match.getAttribute('language') || '').split('_')[0];
                if (cur_lang === best_lang) {
                    best_match = match;
                    break;
                }
            }

            if (best_match) {
                var result = best_match.textContent;
                if (translator) {
                    result = translator(result);
                }
                set(dest, result);
            } else {
                set(dest, '');
            }
        }

        var best_lang = (eval_path(doc, './field[@name="dc.language"]', 'STRING') || '').split('_')[0];
        set('sprache', best_lang);

        from_doc('dc.title', 'titel');
        from_doc('dc.title.translated', 'untertitel');
        from_doc('dc.date.issued', 'erscheinungs_jahr', function (s) {
            return trim(s.split('-')[0]);
        });
        from_doc('dc.format.extent', 'seitenzahl', function (s) {
            return trim(s.split('Seite')[0]);
        });
        from_doc('dc.identifier.uri', 'url');
        from_doc('refubium.note.author', 'verlag');
        from_doc('dc.description.abstract', 'abstract');

        add_authors_by_iter_lastname_comma_firstname(eval_path(doc, './field[@name="dc.contributor.author"]', 'ORDERED'));
    }

    function success_swb (data) {
        var doc = eval_path(data, '/swb', 'FIRST');

        function from_doc (src, dest) {
            return eval_path(doc, './field[@name="' + src + '"]', 'STRING', dest);
        }

        from_doc('T1', 'titel');
        from_doc('T2', 'untertitel');
        from_doc('CY', 'erscheinungs_ort');
        from_doc('PY', 'erscheinungs_jahr');
        from_doc('SN', 'isbn');
        from_doc('PB', 'verlag');

        var e = /^(.*?)\s*(?:Aufl\.|Auflage|ed\.|edition)?$/i.exec(from_doc('ET', 'auflage'));
        if (e) {
            set('auflage', e[1]);
        }

        var e = /^(.*?)\s*S\.$/.exec(from_doc('EP', 'seitenzahl') || '');
        if (e) {
            set('seitenzahl', e[1]);
        }

        var e = /^(.*?)\s*;\s*(.*)$/.exec(from_doc('T3', 'bandzaehlung') || '');
        if (e) {
            set('schriftenreihe', e[1]);
            set('bandzaehlung', e[2]);
        } else {
            set('schriftenreihe', '');
        }

        add_authors_by_iter_lastname_comma_firstname(eval_path(doc, './field[@name="AU" or @name="A2" or @name="A3"]', 'ORDERED'));
    }

    const WE_REGEXES = [
        null,
        /Veterinary\s*Anatomy/i,
        /Veterinary\s*Physiology/i,
        /Veterinary\s*Biochemistry/i,
        /Animal\s*Nutrition/i,
        /Virology/i,
        /Immunology/i,
        /Microbiology\s*and\*Epizootic/i,
        /Food\s*Safety|Food\s*Hygiene/i,
        null,
        /Animal\s*Hygiene|Environmental\s*Health/i,
        /Animal\sWelfare|Animal\s*Behavior|Laboratory\*Animal\*Science/i,
        /Veterinary\s*Pathology/i,
        /Parasitology|Tropical\*Veterinary\*Medicine/i,
        /Pharmacology|Toxicology/i,
        /Poultry\s*Diseases/i,
        /Veterinary\*Epidemiology|Biostatistics/i,
        /Equine\s*Clinic/i,
        /Ruminant\s*Clinic|Swine\*Clinic/i,
        /Animal\*Reproduction/i,
        /Animal\*Clinic/i,
    ];

    function success_crossref (data) {
        const doc = eval_path(data, '/crossref/journal', 'FIRST');

        function eval_paths (src, dest, paths) {
            let data;
            const { length } = paths;
            for (let index = 0; (index < length) && (data == null); ++index) {
                const node = eval_path(src, paths[index], 'FIRST');
                if (node) {
                    data = node.textContent;
                }
            }
            if (dest) {
                set(dest, data || '');
            }
            return data;
        }

        const journal_article = eval_path(doc, './journal_article', 'FIRST');
        if (journal_article) {
            set(
                'titel',
                (eval_paths(journal_article, null, ['./titles/title']) || '').trim().replace(/\s+/g, ' '),
            );

            eval_paths(journal_article, 'seitenzahl', ['./pages/first_page']);
            eval_paths(journal_article, 'seitenzahl_ende', ['./pages/last_page']);
            eval_paths(journal_article, 'doi', ['./doi_data/doi']);
            eval_paths(journal_article, 'url', ['./doi_data/resource']);
        }

        const journal_issue = eval_path(doc, './journal_issue', 'FIRST');
        if (journal_issue) {
            eval_paths(journal_issue, 'erscheinungs_jahr', [
                './publication_date[@media_type="print"]/year',
                './publication_date[@media_type="online"]/year',
                './publication_date/year',
            ]);
            eval_paths(journal_issue, 'bandzaehlung', ['./journal_volume/volume']);
            eval_paths(journal_issue, 'heftzaehlung', ['./issue']);
        }

        const journal_metadata = eval_path(doc, './journal_metadata', 'FIRST');
        if (journal_metadata) {
            eval_paths(journal_metadata, 'sprache', ['./@language']);

            const issn = eval_paths(journal_metadata, null, [
                './issn[@media_type="print"]',
                './issn[@media_type="electronic"]',
                './issn',
            ]);
            const title = eval_paths(journal_metadata, null, ['./full_title']);
            const abbrev = eval_paths(journal_metadata, null, ['./abbrev_title']);
            set_issn(issn, { title, abbrev });
        }

        add_authors_by_iter_generic(
            eval_path(
                doc,
                './journal_article/contributors/person_name[@contributor_role="author" or count(@contributor_role)=0]',
                'ORDERED',
            ),
            function (authorI) {
                const firstname = eval_paths(authorI, null, ['./given_name']);
                const lastname = eval_paths(authorI, null, ['./surname']);

                let we = null;
                let affiliation;
                const affiliations = eval_path(authorI, './affiliation', 'ORDERED');
                while ( (affiliation = affiliations()) ) {
                    affiliation = affiliation.textContent;
                    if (!/Freie\s*Universit(?:ä|ae?)t\s*Berlin|Free\s*University\s*Berlin/i.exec(affiliation)) {
                        continue;
                    }
                    const regexes = WE_REGEXES;
                    const { length } = regexes;
                    for (let index = 0; index <= length; ++index) {
                        const regex = regexes[index];
                        if (regex && regex.exec(affiliation)) {
                            we = index;
                            break;
                        }
                    }
                    if (we && we !== 100) {
                        break;
                    }
                    we = 100;
                }

                return { firstname, lastname, we };
            },
        );
    }

    function error (data, err, xhr) {
        echo('warn', 'Fehler (' + data.statusText + ') - bitte versuchen Sie es erneut');
    }

    function import_fun (remote, cb, input) {
        function success (data) {
            if (!XPathResult || typeof data.evaluate !== 'function') {
                echo('warn', 'Ihr Browser ist veraltet und kann keine Dokumente importieren.');
                echo('confirm', 'Bitte verwenden Sie zum Beispiel einen aktuellen Firefox!');
                return;
            }
            try {
                pubdb.pub_new_import_data = data;
                cb(data);
            } catch (e) {
                if (e === NO_RESULT_FOUND) {
                    echo('warn', 'Es wurden keine entsprechenden Katalogdaten gefunden!');
                    return;
                }
                throw e;
            }
        }

        return function (q) {
            if (input) {
                $(`#main_form [name="${input}"]`).val(q);
            }

            set(
                'bemerkung',
                `Übernommen mittels Import "${input}" mit der Kennung "${q}" am "${date_berlin(true)}".\n`,
            );

            if (q.trim().startsWith('<')) {
                try {
                    var doc = new DOMParser().parseFromString(q, 'text/xml');
                    next_tick(function () {
                        success(doc);
                    });
                } catch (ex) {
                    console.log(ex);
                    error({ statusText: ex });
                }
            } else {
                ajax_post(pubdb.path_root + '/remote/' + remote + '/', {q}, success, error);
            }
        };
    }

    pubdb.pub_new_import = {
        pubmed:   import_fun('pubmed',   success_pubmed,   'pubmed'),
        swb:      import_fun('swb',      success_swb,      'swb'),
        refubium: import_fun('refubium', success_refubium, 'refubium'),
        sep:      import_fun('sep',      success_sep,      'sep'),
        crossref: import_fun('crossref', success_crossref, 'crossref'),
    };

    function add_button (src, onclick) {
        var pubmed_import_button = $('<button/>', {
            text: 'Publikationsdaten aus ' + src + ' auslesen',
            on: {
                click: function () {
                    next_tick(onclick);
                    return false;
                }
            },
            style: 'margin: 20px 0 0 20px; display: block;',
            insertBefore: $('#main_form form')
        });

        if (XPathResult && typeof document.evaluate === 'function') {
            return;
        }

        pubmed_import_button.css({
            'border-color': '#333',
            'background-color': '#666'
        });
        onclick = () => confirm(
            'PubMed-Import nicht möglich',
            '<p>' +
                'Leider ist es mit dem Internet Explorer nicht möglich Datensätze aus ' + src + ' zu importieren, ' +
                'da der Browser die benötigte Funktion ' +
                '<a href="https://developer.mozilla.org/en-US/docs/Web/API/document.evaluate"><tt>document.evaluate</tt></a> ' +
                'nicht unterstützt.' +
            '</p>' +
            '<p>' +
                'Bitte verwenden Sie Firefox, Chrome, Opera oder Safari zum Importieren von ' + src + '-Datensätzen.' +
            '</p>',
            [['abbrechen']],
            'html',
        );
    }

    if (pub.id) {
        return;
    } else if (pub.typ === 'wissenschaftlicher_beitrag') {
        add_button('PubMed', () => prompt(
            'Publikationsdaten aus PubMed auslesen',
            'Bitte geben Sie die PubMed-ID (pmid) der Publikation an, deren Daten Sie übernehmen wollen.',
            'pmid:',
            '123456',
            [
                ['auslesen', function strip_url (q) {
                    var e = /\/(\d+)(?:\?.*)?$/.exec(q);
                    if (e) {
                        q = e[1];
                    }
                    pubdb.pub_new_import.pubmed(q);
                }],
                ['abbrechen']
            ],
        ));
        add_button('SEP', () => prompt(
            'Publikationsdaten aus SEP auslesen',
            'Bitte geben Sie die SEP-ID der Publikation an, deren Daten Sie übernehmen wollen.',
            'ID:',
            '64174',
            [
                ['auslesen', function strip_url (q) {
                    var e = /\/(\d+)(?:\?.*)?$/.exec(q);
                    if (e) {
                        q = e[1];
                    }
                    pubdb.pub_new_import.sep(q);
                }],
                ['abbrechen'],
            ],
        ));
        add_button('DOI', () => prompt(
            'Publikationsdaten per DOI aus CrossRef auslesen',
            'Bitte geben Sie die DOI der Publikation an, deren Daten Sie übernehmen wollen.',
            'ID:',
            '10.1111/vsu.13725',
            [
                ['auslesen', function strip_url (q) {
                    var e =  /(?:10\.\d{4,9}\/[-._;()\/:A-Z0-9]+)(?=$|#|\?)/i.exec(q);
                    if (e) {
                        q = e[0];
                    }
                    pubdb.pub_new_import.crossref(q);
                }],
                ['abbrechen'],
            ],
        ));
    } else if (pub.typ === 'hochschulschrift') {
        add_button('Refubium', () => prompt(
            'Publikationsdaten aus FU-Dissertationsdatenbank auslesen',
            'Bitte geben Sie die ID oder die komplette URL der Publikation an, deren Daten Sie übernehmen wollen.',
            'URL oder ID:',
            'https://refubium.fu-berlin.de/handle/fub188/1234',
            [
                ['auslesen', function (q) {
                    var e = /(\d+)(?:[?#].*)?$/.exec(q);
                    if (e) {
                        q = e[1];
                    }
                    pubdb.pub_new_import.refubium(q);
                }],
                ['abbrechen'],
            ],
        ));
    } else if (['buchautorenschaft', 'buchbeitrag', 'buchherausgeberschaft'].indexOf(pub.typ) >= 0) {
        add_button('Online-Katalog', () => prompt(
            'Publikationsdaten aus einem Online-Katalog auslesen',
            [
                $('<p/>').text('Bitte geben Sie die ISBN des Buches an, dessen Daten Sie übernehmen wollen.'),
                $('<p/>').text('Folgende Datenbanken stehen Ihnen zur Verfügung:'),
                $('<dl/>').append([
                    $('<dt/>').text('SWB'),
                    $('<dd/>').text('Südwestdeutscher Bibliotheksverbund')
                ])
            ],
            'ISBN:',
            '978-1-905319-29-9',
            [['SWB', pubdb.pub_new_import.swb], ['abbrechen']],
            'html',
        ));
    }
});
